import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../../mutation-types';
import CrmDealOriginsAPI from '../../../api/crm/dealOrigins';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

export const getters = {
    getUIFlags(_state) {
        return _state.uiFlags;
    },
    getDealOrigins(_state) {
        return _state.records;
    },
    getDealOriginById: _state => id => {
        return _state.records.find(r => r.id === Number(id));
    },
};

export const actions = {
    get: async ({ commit }) => {
        commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isFetching: true });
        try {
            const response = await CrmDealOriginsAPI.get();
            commit(types.SET_CRM_DEAL_ORIGINS, response.data);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isFetching: false });
        }
    },
    create: async ({ commit }, originObj) => {
        commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isCreating: true });
        try {
            const response = await CrmDealOriginsAPI.create(originObj);
            commit(types.ADD_CRM_DEAL_ORIGIN, response.data);
            return response.data;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isUpdating: true });
        try {
            const response = await CrmDealOriginsAPI.update(id, updateObj);
            commit(types.EDIT_CRM_DEAL_ORIGIN, response.data);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isDeleting: true });
        try {
            await CrmDealOriginsAPI.delete(id);
            commit(types.DELETE_CRM_DEAL_ORIGIN, id);
        } catch (error) {
            throw new Error(error);
        } finally {
            commit(types.SET_CRM_DEAL_ORIGINS_UI_FLAG, { isDeleting: false });
        }
    },
};

export const mutations = {
    [types.SET_CRM_DEAL_ORIGINS_UI_FLAG](_state, data) {
        _state.uiFlags = { ..._state.uiFlags, ...data };
    },
    [types.SET_CRM_DEAL_ORIGINS]: MutationHelpers.set,
    [types.ADD_CRM_DEAL_ORIGIN]: MutationHelpers.create,
    [types.EDIT_CRM_DEAL_ORIGIN]: MutationHelpers.update,
    [types.DELETE_CRM_DEAL_ORIGIN]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
